import { displayUserOptionsComponent } from './display-options.components';
import './display-user-options.scss';

export const displayUserOptions =  angular
.module('common.displayUserOptions', [])
.component('displayUserOptions', displayUserOptionsComponent)
.name


// WEBPACK FOOTER //
// ./src/app/common/components/display-users-options/display-options.module.js